import { render } from "./MiniFolderIcon.vue?vue&type=template&id=967e984a"
import script from "./MiniFolderIcon.vue?vue&type=script&lang=js"
export * from "./MiniFolderIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__